import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";

// Admin Panel
import AdminDashboard from "./pages/admin/AdminDashboard";
import Dashboard from "./pages/admin/Dashboard";

// Products
import ProductsList from "./pages/admin/Products/ProductsList";
import ProductForm from "./pages/admin/Products/ProductForm";
import ProductDetails from "./pages/admin/Products/ProductDetails";
import ImportProducts from "./pages/admin/Products/ImportProducts";
import Categories from "./pages/admin/Products/Categories";
import ProductVariants from "./pages/admin/Products/ProductVariants";
import EditProduct from "./pages/admin/Products/EditProduct";
import ProductSEO from "./pages/admin/Products/ProductSEO";
import ProductAttributes from "./pages/admin/Products/ProductAttributes";
import AddProduct from "./pages/admin/Products/AddProduct"; // Dodato ako fali

// Orders
import Orders from "./pages/admin/Orders";

// Users
import Users from "./pages/admin/Users";

// Settings
import Settings from "./pages/admin/Settings";

// 404 Not Found stranica
const NotFound = () => <h1>Stranica nije pronađena</h1>;

function App() {
  return (
    <Router>
      <Routes>
        {/* AUTH RUTE */}
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* ADMIN PANEL */}
        <Route path="/admin" element={<AdminDashboard />}>
          <Route index element={<Dashboard />} />
          {/* PROIZVODI */}
          <Route path="proizvodi" element={<ProductsList />} />
          <Route path="proizvodi/dodaj" element={<AddProduct />} />{" "}
          {/* OVO JE NOVO */}
          <Route path="proizvodi/izmena" element={<EditProduct />} />{" "}
          {/* BEZ ID */}
          <Route path="proizvodi/izmena/:id" element={<EditProduct />} />{" "}
          {/* SA ID */}
          <Route path="proizvodi/detalji/:id" element={<ProductDetails />} />
          <Route path="proizvodi/import" element={<ImportProducts />} />
          <Route path="proizvodi/kategorije" element={<Categories />} />
          <Route path="proizvodi/varijante" element={<ProductVariants />} />
          <Route path="proizvodi/seo" element={<ProductSEO />} />
          <Route path="proizvodi/atributi" element={<ProductAttributes />} />
          {/* PORUDŽBINE */}
          <Route path="porudzbine" element={<Orders />} />
          {/* KORISNICI */}
          <Route path="korisnici" element={<Users />} />
          {/* PODEŠAVANJA */}
          <Route path="podesavanja" element={<Settings />} />
        </Route>

        {/* 404 Not Found */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
